var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fdfdfd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.732 1.898)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.607,4.455l-.519-.9a1.594,1.594,0,0,0-2.174-.587h0A1.587,1.587,0,0,1,9.74,2.4a1.526,1.526,0,0,1-.214-.763h0A1.594,1.594,0,0,0,7.932,0H6.887A1.587,1.587,0,0,0,5.3,1.594h0A1.594,1.594,0,0,1,3.707,3.166a1.526,1.526,0,0,1-.763-.214h0A1.594,1.594,0,0,0,.77,3.539l-.557.915a1.594,1.594,0,0,0,.58,2.174h0a1.594,1.594,0,0,1,.8,1.381,1.594,1.594,0,0,1-.8,1.381h0a1.587,1.587,0,0,0-.58,2.166h0l.526.908a1.594,1.594,0,0,0,2.174.618h0a1.579,1.579,0,0,1,2.166.58,1.526,1.526,0,0,1,.214.763h0a1.594,1.594,0,0,0,1.594,1.594H7.932a1.594,1.594,0,0,0,1.594-1.587h0a1.587,1.587,0,0,1,1.594-1.594,1.625,1.625,0,0,1,.763.214h0a1.594,1.594,0,0,0,2.174-.58h0l.549-.915a1.587,1.587,0,0,0-.58-2.174h0a1.587,1.587,0,0,1-.58-2.174,1.564,1.564,0,0,1,.58-.58h0a1.594,1.594,0,0,0,.58-2.166h0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.197,
    cy: 2.197,
    r: 2.197,
    transform: "translate(5.217 5.812)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.f0add9794f5486d388d1b15628b6b27e.svg";
export { ForwardRef as ReactComponent };